import { makeId } from '../utils'

export const getArticle = ({
  title,
  alternateName,
  alternativeHeadline,
  articleSection,
  datePublished,
  dateModified,
  url,
  publisherUrl,
  fullname,
  courtAcronym,
  articleBody,
  description,
}: {
  title: string
  alternateName: string
  alternativeHeadline: string
  articleSection: string
  datePublished: string
  dateModified: string
  url: string
  publisherUrl: string
  fullname: string
  courtAcronym: string
  articleBody: string
  description?: string
}) => {
  return {
    '@type': 'Article',
    '@id': makeId(url, 'article'),
    url,
    mainEntityOfPage: { '@id': makeId(url, 'webpage') },
    headline: title,
    alternateName,
    alternativeHeadline,
    articleSection,
    articleBody,
    image: [
      'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-675.png',
      'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-1200.png',
      'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-900.png',
    ],
    datePublished,
    dateModified,
    isAccessibleForFree: true,
    author: {
      '@type': 'Person',
      name: `${fullname} ${courtAcronym}`,
      url: publisherUrl,
    },
    description,
  }
}
